import { render, staticRenderFns } from "./UploadTemp.vue?vue&type=template&id=54f082d8&"
import script from "./UploadTemp.vue?vue&type=script&lang=js&"
export * from "./UploadTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports